'use strict';

import { openNotification } from './notifications';

export const markAsClean = (bedNumber, declaredBy) => {
    return fetch(`${process.env.REACT_APP_API_URL}/beds/${bedNumber}/cleaning-logs`, {
        method: 'POST',
        credentials: 'include',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify({ declaredBy: declaredBy || null }),
    })
    .then(async res => {
        if (res.status === 201) return res.json();
        throw await res.json();
    })
    .then(res => {
        openNotification({
            type: 'success',
            message: res.message
        });
        return true;
    })
    .catch(err => {
        openNotification({
            type: 'error',
            message: err.message || 'Erreur lors de l\'enregistrement du nettoyage'
        });
        return false;
    });
};

export const fetchCleaningLogs = (bedNumber) => {
    return fetch(`${process.env.REACT_APP_API_URL}/beds/${bedNumber}/cleaning-logs`, {
        method: 'GET',
        credentials: 'include',
        headers: new Headers({
            'Content-Type': 'application/json',
        })
    })
    .then(async res => {
        if (res.status === 200) return res.json();
        throw await res.json();
    })
    .catch(err => {
        console.error('Erreur chargement historique nettoyage:', err);
        return [];
    });
};
